// Content data extracted from the Simpel home page design (mock/static content)

export const NAV_LINKS = [
  { label: "Why Simpel", href: "#why" },
  { label: "AI Opportunities", href: "#opportunities", to: "/ai-opportunities" },
  { label: "How we Transform", href: "#transform", to: "/transform" },
  { label: "Cognitive AI", href: "#cognitive", to: "/cognitive" },
  { label: "Insights", href: "#insights", to: "/insights" },
  { label: "About", href: "#about", to: "/about" },
];

// Floating badges over the hero image (dark navy pills)
export const HERO_BADGES = [
  { label: "Customers", sub: "Create value", icon: "Heart", iconBg: "#06256A", left: 109, top: 53 },
  { label: "People", sub: "Empower talent", icon: "User", iconBg: "#223257", left: 519, top: 50 },
  { label: "Revenue", sub: "Unlock growth", icon: "TrendingUp", iconBg: "#1B4932", left: 48, top: 287 },
  { label: "Operations", sub: "Increase efficiency", icon: "Settings2", iconBg: "#253C8B", left: 597, top: 290 },
  { label: "Finance", sub: "Drive performance", icon: "LineChart", iconBg: "#0A5D60", left: 85, top: 384 },
  { label: "Technology", sub: "Modernize with purpose", icon: "Cpu", iconBg: "#1294A1", left: 185, top: 470 },
  { label: "Knowledge", sub: "Turn insight into action", icon: "Lightbulb", iconBg: "#665E3E", left: 544, top: 468 },
];

// AI Opportunity cards (light section) - scattered around central AI orb
export const OPPORTUNITY_CARDS = [
  { img: "opp-revenue", title: "Revenue", sub: "Find and win more", left: 623.5, top: 48 },
  { img: "opp-customers", title: "Customers", sub: "Deliver exceptional experiences", left: 829.5, top: 28 },
  { img: "opp-operations", title: "Operations", sub: "Do more with less", left: 1035.5, top: 48 },
  { img: "opp-finance", title: "Finance", sub: "Improve profitability", left: 530, top: 236 },
  { img: "opp-technology", title: "Technology", sub: "Build for what's next", left: 1149, top: 236 },
  { img: "opp-people", title: "People", sub: "Unlock human potential", left: 736.5, top: 314 },
  { img: "opp-knowledge", title: "Knowledge", sub: "Put knowledge to work", left: 942.5, top: 314 },
];

// Simpel LOOP nodes (dark approach section). dotSide indicates whether the dot is left or right of the label.
export const LOOP_NODES = [
  { title: "Goals", sub: "Define what success looks like", left: 638, top: 105, dotSide: "right", w: 200 },
  { title: "Discover", sub: "High-value opportunities", left: 1162, top: 110, dotSide: "left", w: 197 },
  { title: "Understand", sub: "Your business in context", left: 906, top: 54, dotSide: "left", w: 197 },
  { title: "Evolve", sub: "Scale and create new value", left: 604, top: 208, dotSide: "right", w: 170 },
  { title: "Prioritize", sub: "High-value opportunities", left: 1224, top: 208, dotSide: "left", w: 197 },
  { title: "Measure", sub: "Track real impact", left: 666, top: 318, dotSide: "right", w: 158 },
  { title: "Integrate", sub: "Embed into your business", left: 918, top: 372, dotSide: "left", w: 197 },
  { title: "Build", sub: "Develop and validate", left: 1162, top: 318, dotSide: "left", w: 175 },
];

// A More Intelligent Tomorrow evolution steps
export const TOMORROW_STEPS = [
  { img: "tom-software", title: "Software", sub: "Stores information" },
  { img: "tom-automation", title: "Automation", sub: "Follows rules" },
  { img: "tom-agents", title: "Agents", sub: "Take action" },
  { img: "tom-workers", title: "Digital Workers", sub: "Augment your team" },
  { img: "tom-enterprise", title: "Cognitive Enterprise", sub: "A more capable business" },
];

export const CTA_FEATURES = ["AI analysis", "Real opportunities", "Tailored to your business"];
